import { useStaticQuery, graphql } from "gatsby"

const useBio = () => {

    const data = useStaticQuery(graphql`
    query{
        allDatoCmsBio(filter: {slug: {eq: "bio"}}){
          edges{
            node{
              description
              img {
                fluid(maxWidth:400){
                    ...GatsbyDatoCmsFluid
                }
              }
            }
          }
        }
      }
      
    `)

    return  data.allDatoCmsBio.edges[0].node;
}

export default useBio
